module.exports = __webpack_public_path__ + "img/hand-fist.833cb2d4.svg";